import './App.css';
import { Route, Routes } from 'react-router-dom';
import SiteLayout from './layouts/site-layout';
import HomePage from './pages/home';
import AuthGuard from './pages/login/auth-guard';
import AuthPage from './pages/login/auth';
import UsuariosPage from './pages/usuarios';
import PerfilBusquedaPage from './pages/perfil-busquedas';
import ConjuntoBusquedaPage from './pages/conjunto-busquedas';
import OportunidadesPage from './pages/oportunidades';
import ColaTrajoItemPage from './pages/cola-trabajos';

function App() {
    return (
        <Routes>
            <Route element={<SiteLayout />}>
                <Route element={<AuthGuard />}>
                    <Route path='/' element={<HomePage />} />

                    <Route path='/usuarios'>
                        <Route index element={<UsuariosPage />} />
                    </Route>

                    <Route path='/perfil-busqueda'>
                        <Route index element={<PerfilBusquedaPage />} />
                    </Route>

                    <Route path='/conjunto-busqueda'>
                        <Route index element={<ConjuntoBusquedaPage />} />
                    </Route>

                    <Route path='/oportunidades'>
                        <Route index element={<OportunidadesPage />} />
                    </Route>

                    <Route path='/cola-trabajo'>
                        <Route index element={<ColaTrajoItemPage />} />
                    </Route>
                </Route>
            </Route>

            <Route path='/login' element={<AuthPage />} />
        </Routes>
    );
}

export default App;
